import { render, staticRenderFns } from "./MailOnlineBizTopic.vue?vue&type=template&id=3839d06a&lang=pug"
import script from "./MailOnlineBizTopic.vue?vue&type=script&lang=js"
export * from "./MailOnlineBizTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports